import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { ICompleteOnboardingStepV1Body } from './complete-onboarding-step-v1-request';
import type { ICompleteOnboardingStepV1Response } from './complete-onboarding-step-v1-response';
import { completeOnboardingStepV1ResponseSchema } from './complete-onboarding-step-v1-response';

export async function completeOnboardingStepV1Api(
  body: ICompleteOnboardingStepV1Body,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ICompleteOnboardingStepV1Response>> {
  return putRequest<ICompleteOnboardingStepV1Response>({
    path: '/account/onboarding/v1',
    body,
    schema: completeOnboardingStepV1ResponseSchema,
    options,
  });
}
